import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

import CurrentLanguage from '@/components/CurrentLanguage.vue';
import {
  EventSource,
  SourceTrack,
  trackItems,
} from '@/models/event-source.model';
import { useEvents, Event } from '@/services/events.composable';
import { Actions, Mutations, ShiftCMSState } from '@/store';
import { EventsActions, EventsState } from '@/stores/events.store';
import { NEW_ID } from '@/util/constants';
import { computed, onMounted, PropType, ref, onBeforeUnmount } from 'vue';
import { useStore } from 'vuex';


export default /*@__PURE__*/_defineComponent({
  __name: 'EventSourceForm',
  props: {
  data: {
    type: Object as PropType<EventSource>,
  },
},
  setup(__props) {

const store = useStore<ShiftCMSState & { ev: EventsState }>();

const events = useEvents();

const props = __props;

const valid = ref<boolean>(false);

const source = ref<EventSource>({
  id: NEW_ID,
  creationDate: '',
  name: '',
  url: '',
  track: SourceTrack.C,
  lastSuccessfulRun: null,
  lastEventCount: 0,
  consecutiveFailures: 0,
  enabled: false,
});

const action = computed<string>(() =>
  source.value.id === NEW_ID ? 'Add' : 'Save',
);

const saveEventSource = async () => {
  let success: boolean = false;
  if (valid.value) {
    if (source.value.id === NEW_ID) {
      success = await store.dispatch(
        EventsActions.AddEventSource,
        source.value,
      );
    } else {
      success = await store.dispatch(
        EventsActions.UpdateEventSource,
        source.value,
      );
    }
  }
  if (success) {
    events.emit(Event.Saved, true);
    store.dispatch(Actions.ShowNotification, {
      message: 'Saved Event Source',
      type: 'success',
    });
    store.commit(Mutations.HideDrawer);
    store.dispatch(EventsActions.GetEventSources);
  } else {
    store.dispatch(Actions.ShowNotification, {
      message: 'Failed to save Event Source',
      type: 'error',
    });
  }
};

const updateLanguage = async () => {
  if (source.value.id === NEW_ID) {
    Object.assign(source, { title: '' });
  } else {
    const cat = await store.dispatch(
      EventsActions.GetEventSource,
      source.value.id,
    );

    if (cat) {
      Object.assign(source.value, { ...cat });
    }
  }
};

onBeforeUnmount(() => {
  events.off(Event.LanguageChanged, updateLanguage);
});

onMounted(() => {
  events.on(Event.LanguageChanged, updateLanguage);

  if (props.data) {
    Object.assign(source.value, {
      ...props.data,
    });
  }
});

const removeLabel = async () => {
  if (
    source.value &&
    source.value.id !== NEW_ID &&
    confirm('Are you absolutely sure you want to delete this "EventSource"?')
  ) {
    store.dispatch(EventsActions.DeleteEventSource, source.value.id);

    store.commit(Mutations.HideDrawer);
  }
};

function checkUrl(url: string) {
  window.open(url, '_new');
}

return (_ctx: any,_cache: any) => {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_form = _resolveComponent("v-form")!

  return (_openBlock(), _createBlock(_component_v_form, {
    modelValue: valid.value,
    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((valid).value = $event)),
    onSubmit: _withModifiers(saveEventSource, ["prevent"])
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_container, null, {
        default: _withCtx(() => [
          _createElementVNode("h2", null, [
            _createTextVNode(_toDisplayString(_ctx.$t(action.value)) + " a event source ", 1),
            _createVNode(CurrentLanguage)
          ]),
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, { cols: "9" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_text_field, {
                    modelValue: source.value.name,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((source.value.name) = $event)),
                    label: "Title",
                    required: ""
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, { cols: "9" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_text_field, {
                    modelValue: source.value.url,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((source.value.url) = $event)),
                    label: "URL",
                    required: ""
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, { class: "pt-6" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    block: "",
                    color: "info",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (checkUrl(source.value.url))),
                    disabled: source.value.url == ''
                  }, {
                    default: _withCtx(() => _cache[6] || (_cache[6] = [
                      _createTextVNode("Check")
                    ])),
                    _: 1
                  }, 8, ["disabled"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, { align: "right" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_checkbox, {
                    label: "Enabled",
                    modelValue: source.value.enabled,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((source.value.enabled) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_select, {
                    modelValue: source.value.track,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((source.value.track) = $event)),
                    label: "Processing track",
                    class: "calculation-field",
                    items: _unref(trackItems),
                    "hide-details": "auto",
                    style: { background: 'white' },
                    required: ""
                  }, null, 8, ["modelValue", "items"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, null, {
                default: _withCtx(() => [
                  (source.value.track === _unref(SourceTrack).A)
                    ? (_openBlock(), _createBlock(_component_v_alert, {
                        key: 0,
                        color: "success"
                      }, {
                        default: _withCtx(() => _cache[7] || (_cache[7] = [
                          _createTextVNode("Aggregator "),
                          _createElementVNode("strong", null, "APIs", -1),
                          _createTextVNode(" (Luma, Mobilizon, Eventbrite). Fully structured, no LLM needed.")
                        ])),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (source.value.track === _unref(SourceTrack).B)
                    ? (_openBlock(), _createBlock(_component_v_alert, {
                        key: 1,
                        color: "yellow"
                      }, {
                        default: _withCtx(() => _cache[8] || (_cache[8] = [
                          _createElementVNode("strong", null, "Custom scrapers", -1),
                          _createTextVNode(" (wijkconnect, buurtgroen020, halloijburg). Deterministic HTML scraping per known site layout.")
                        ])),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (source.value.track === _unref(SourceTrack).C)
                    ? (_openBlock(), _createBlock(_component_v_alert, {
                        key: 2,
                        color: "red"
                      }, {
                        default: _withCtx(() => _cache[9] || (_cache[9] = [
                          _createElementVNode("strong", null, "LLM extraction", -1),
                          _createTextVNode(". Any URL — markdown gets fed to Haiku, which extracts events. ")
                        ])),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, { col: "2" }),
              _createVNode(_component_v_col, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    class: "mt-2",
                    type: "button",
                    color: "warning",
                    onClick: removeLabel,
                    block: ""
                  }, {
                    default: _withCtx(() => _cache[10] || (_cache[10] = [
                      _createTextVNode("Delete")
                    ])),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    class: "mt-2",
                    type: "reset",
                    block: ""
                  }, {
                    default: _withCtx(() => _cache[11] || (_cache[11] = [
                      _createTextVNode("Reset")
                    ])),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    class: "mt-2",
                    type: "submit",
                    color: "success",
                    block: ""
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(action.value), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, { col: "2" })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})